"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var failedPaymentErrorStyles_1 = require("./failedPaymentErrorStyles");
var react_intl_1 = require("react-intl");
var PaymentSummary_1 = require("../../../../../gql/checkout4/components/payment/paymentSummary/PaymentSummary");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var FailedPaymentError = function () {
    var _a = core_1.useTheme().checkoutLite.confirmation, showFailedPaymentIcon = _a.showFailedPaymentIcon, showInlineFailedPaymentIcon = _a.showInlineFailedPaymentIcon;
    var showSecureDisclaimerTextOnFailedPayment = usePlatformConfig_1.default().platformConfig.checkout.showSecureDisclaimerTextOnFailedPayment;
    var styles = failedPaymentErrorStyles_1.default();
    var intl = react_intl_1.useIntl();
    return (<core_1.Box className={styles.container}>
      {showSecureDisclaimerTextOnFailedPayment && <PaymentSummary_1.default />}
      {showFailedPaymentIcon && (<core_1.Box display="flex">
          <icons_1.Cancel className={styles.icon}/>
        </core_1.Box>)}
      <core_1.Typography variant="subtitle1" data-test="payment_page:payment_error:subtitle" className={styles.subTitle}>
        {showInlineFailedPaymentIcon && <icons_1.Cancel className={styles.icon}/>}
        <Translation_1.default id="trans__checkout__payment_page__failed_subtitle"/>
      </core_1.Typography>
      <core_1.Typography component="div" variant="body1" data-test="payment_page:payment_error:description1" className={styles.description}>
        <Translation_1.default id="trans__checkout__payment_page__failed_description1" values={{
        email: (<a className={styles.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__confirmation_page__email_on_description_reserve_online_journey',
        })}>
                <Translation_1.default id={'trans__checkout__confirmation_page__email_on_description_reserve_online_journey'}/>
              </a>),
    }}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = FailedPaymentError;
